import './index.scss'
$("footer .backtop").click(function () {
    $("html,body").animate({scrollTop: 0},"fast");
})
$(".ph-footer .backtop").click(function () {
    $("html,body").animate({scrollTop: 0},"fast");
})
